module.exports = __webpack_public_path__ + "static/media/key.e8c94b30.svg";